import React from "react";
import {
    makeStyles,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
}));

function ToolbarMixin() {
    const classes = useStyles();
    const theme = useTheme();
    const isSmUp = useMediaQuery(theme.breakpoints.up("sm"));

    return <>{isSmUp ? null : <div className={classes.toolbar} />}</>;
}

export default ToolbarMixin;
